import React from 'react'
import "./style.css"
const Loader = (props) => {
    const fetchingLoader = {
        width: "80px",
        height: "80px",
        margin: "20px auto",
        borderWidth: "10px",
        borderStyle: "double solid solid",
        borderColor: "#008060",
    }
    return (
        <div className="loader" style={props.style ? props.style : fetchingLoader}></div>
    )
}

export default Loader;